import { useState } from "react"
import { Card, Col, Container, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import StepOne from "../components/autoagendamiento/StepOne"
import StepTree from "../components/autoagendamiento/StepTree"
import StepTwoAutoagendamiento from "../components/autoagendamiento/StepTwoAutoagendamiento"
import StepTwoAutoagendamientoMexico from "../components/autoagendamiento/StepTwoAutoagendamientoMexico"
import ComponentModalErrorSever from "../components/ComponentModalErrorSever"


function AutoagendamientoOnDemand({t, speciality, account, onDemand, appointment, company, source}) {
    const [currentStep, setCurrentStep] = useState(0)
    const [phoneNumber, setPhoneNumber] = useState(null)
    const [phoneNumber2, setPhoneNumber2] = useState(null)
    const [tipoSangre, setTipoSangre] = useState('')
    const [isPedienteAprobacion, setIsPendienteAprobacion] = useState(false)
    const [reservadoExitosamente, setReservadoExitosamente] = useState(false)
    const [validLink, setValidLink]  = useState(true)
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    const companyType = company ? company : 1
    
    const [initialData, setInitialData] = useState({
        id: '',
        name: '',
        middleName: '',
        lastName: '',
        seccondSurname: '',
        curp: '',
        gender: '',
        dateOfBirthday: '',
        nationality: '',
        externalId: '',
        phoneNumber: '',
        phoneNumber2: '',
        email: '',
        bloodType: '',
        occupation:'',
        address: '',
        peso: '',
        talla: '',
        sintomas: '',
        dayAppointment: '',
        doctorId: '',
        hourDayId: '',
        hourDayHour: '',
        doctorName: '',
        especialidadName: '',
        especialidadId: '',
        account: account,
        company:company,
        currentInsurance: '',
        aceptarTerminos: true,
        location: '',
        neighborhood: '',
        identityDocumentType: '',
        documentNumber: '',
        choiceType: '',
        expediente: '',
        patientRelationship: '',
        hourInit: '',
        candidateDoctors: []
    })

    const makeRequest = (formdata) =>{
        console.log('formSubmit '+ formdata)
    }

    const handleNextStep = (newData, final=false) =>{
        setInitialData(prev=>({...prev, ...newData}))

        if(final){
            makeRequest(newData)
            return;
        }

        setCurrentStep(prev=>prev+1)
    }
    const handlePrevStep = (newData) =>{
        setInitialData(prev=>({...prev, ...newData}))
        setCurrentStep(prev=>prev-1)
    }


    const steps = [
        <StepOne next={handleNextStep} initialData={initialData} 
                 phoneNumber={phoneNumber} tipoSangre={tipoSangre} phoneNumber2={phoneNumber2} setPhoneNumber2={setPhoneNumber2}
                 setPhoneNumber={setPhoneNumber} setTipoSangre={setTipoSangre} company={company} account={account}/>,
        companyType.id === 1 ?
        <StepTwoAutoagendamientoMexico next={handleNextStep} setInitialData={setInitialData} initialData={initialData} 
            prev={handlePrevStep} setShowModalError={setShowModalError} setErrorServer={setErrorServer}
            speciality={speciality}
        /> :
        <StepTwoAutoagendamiento next={handleNextStep} setInitialData={setInitialData} initialData={initialData}
            prev={handlePrevStep} 
            speciality={speciality}
            setShowModalError={setShowModalError} setErrorServer={setErrorServer}
        />,
        <StepTree next={handleNextStep} 
            initialData={initialData} isPedienteAprobacion={isPedienteAprobacion} setValidLink={setValidLink}
            prev={handlePrevStep} setReservadoExitosamente={setReservadoExitosamente} reservadoExitosamente={reservadoExitosamente}
            onDemand={onDemand} appointment={appointment} source={source}/>
        
    ]

    console.log(initialData)

    return (
        <>
            {
                validLink  ?
                <Container fluid className="content">
                    <Row className="pt-5">
                        <Col xs="12" md="12">
                            {steps[currentStep]}
                        </Col>
                    </Row>
                </Container> :
                validLink && onDemand ?
                <Container fluid className="content h-100vh">
                    <Row className="pt-5">
                        <Col xs="12" md={{span: 4, offset: 4}}>
                            <Card className="shadow-sm">
                                <Card.Body>
                                    <label>Si necesitas ayuda contacte con nosotros por favor</label>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container> :
                <Container fluid className="content">
                    <Row className="pt-5">
                        <Col xs="12" md={{span: 4, offset: 4}}>
                            <Card className="shadow-sm">
                                <Card.Body>
                                    <label>Esta liga ya se ha usado, no es posible usarla para concluir tu solicitud. Gracias.</label>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            }
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </>
    );
}

export default withTranslation()(AutoagendamientoOnDemand)
